
define('text!fusion/ui/controls/fusion-test.html',[],function () { return '<div>\r\n    <h5 data-bind="text: text"></h5>\r\n    <h5 data-bind="text: name"></h5>\r\n</div>\r\n';});

